module.exports = __webpack_public_path__ + "media/images/ny-times-60b4e006dbf688ccd8fc068bf3a91e37.svg";